@import 'src/global/media_queries'
  
:host 
  display: block
  width: 100%
  height: 100%
  padding: 0.9rem 0.5rem
  opacity: 0.6
  filter: blur(0.2rem)
  transition: opacity 0.2s linear

  &.swiper-slide-active 
    opacity: 1
    filter: unset

  img
    display: block
    width: 100%
    height: 100%
    object-fit: cover
    object-position: center
    border-radius: 0.5rem
    // box-shadow: 0 0.2rem 0.7rem rgba(0,0,0,0.15)

  @include media(">=tablet")
    padding: 1.4rem 1rem

    img
      border-radius: 0.8rem